import MediaObjectSet from '../Page/MediaObjectSet';

export default MediaObjectSet;
